import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useParams} from 'react-router-dom';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = () => {
    const {id: productId} = useParams();
    
    if (!productId) {
        throw new Error('productId is required');
    }

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper><RecordsTable productId={productId}/></SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
